<template>
  <b-row class="mb-4">
    <b-col cols="12" offset-sm="1" sm="3">
      <label>{{ label }}</label>
    </b-col>
    <b-col cols="12" sm="7">
      <custom-js-editor
        :id="handle"
        :jsCode="inputValue"
        @update-code="$emit('update-field', $event)"
      ></custom-js-editor>
      <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component -->
      <b-form-text v-if="desc" v-html="desc"></b-form-text>
    </b-col>
  </b-row>
</template>

<script>
import CustomJsEditor from '@/components/helper/CustomJsEditor.vue';

export default {
  name: 'CustomJsEditorRow',
  components: {
    CustomJsEditor,
  },
  props: {
    valueFromDb: { type: String, default: null },
    handle: { type: String, default: null },
    label: { type: String, default: null },
    desc: { type: String, default: null },
  },
  data() {
    return {
      inputValue: null,
    };
  },
  created() {
    this.inputValue = this.valueFromDb;
  },
};
</script>
